module.exports = "<chassis-core-form\n    *ngIf=\"structure\"\n    [static]=\"static\"\n    [structure]=\"structure\"\n    [entity]=\"entity\"\n\t(submit)=\"onSubmit($event)\"\n></chassis-core-form>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/components/resource-form/resource-form.component.html
// module id = ./libs/chassis-core/src/app/resources/components/resource-form/resource-form.component.html
// module chunks = main